import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-targets-list",
  templateUrl: "./targets-list.component.html",
  styleUrls: ["./targets-list.component.scss"],
})
export class TargetsListComponent implements OnInit, OnDestroy {
  isloader: boolean = false;
  apisub: Subscription;
  targetList: any = [];
  page: number = 1;
  datalength!: number;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private apiservice: ApiService,
    private route: ActivatedRoute,
    private ls: LoaderServiceService,
    private activemodal: MatDialogRef<TargetsListComponent>
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_CUSTOMERS_BY_ENTITY_ID
      ) {
        console.log(resdata);
        console.log(this.prefilledIds);

        if (resdata.result && resdata.result != null) {
          this.datalength = resdata.result[0].total_count;
          resdata.result.forEach((element: any) => {
            const isMatched = this.prefilledIds.has(element.hash_id);
            if (isMatched) {
              this.selectedTargets.push(element);
            }
            element.selected = this.prefilledIds.has(element.hash_id);
            this.targetList.push(element);
          });
        }
        this.loader = false;
        this.ls.showLoader = false;
        this.isloader = false;
      }

      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENROLL_MEMBERS_SEARCH_BY_TYPE
      ) {
        console.log(resdata);
        if (resdata.result && resdata.result != null) {
          this.datalength = resdata.result[0].total_count;
          resdata.result.forEach((element: any) => {
            const isMatched = this.prefilledIds.has(element.hash_id);
            if (isMatched) {
              this.selectedTargets.push(element);
            }
            element.selected = this.prefilledIds.has(element.hash_id);
            this.targetList.push(element);
          });
        }
        this.loader = false;
        this.ls.showLoader = false;
        this.isloader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ALL_ENROLL_OPEN_INTEREST_BY_ENTITY_ID
      ) {
        console.log(resdata);
        if (resdata.result && resdata.result != null) {
          this.datalength = resdata.result[0]?.total_count;
          resdata.result.forEach((element: any) => {
            const isMatched = this.prefilledIds.has(element.hash_id);
            if (isMatched) {
              this.selectedTargets.push(element);
            }
            element.selected = this.prefilledIds.has(element.hash_id);
            this.targetList.push(element);
          });
        }
        this.loader = false;
        this.ls.showLoader = false;
        this.isloader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_ALL_ENQUIRY_LIST
      ) {
        console.log(resdata);
        if (resdata.result && resdata.result != null) {
          this.datalength = resdata.result[0]?.total_count;
          resdata.result.forEach((element: any) => {
            const isMatched = this.prefilledIds.has(element.hash_id);
            if (isMatched) {
              this.selectedTargets.push(element);
            }
            element.selected = this.prefilledIds.has(element.hash_id);
            this.targetList.push(element);
          });
        }
        this.loader = false;
        this.ls.showLoader = false;
        this.isloader = false;
      }
    });
  }
  prefilledIds: any;
  entityHash: any;
  type: any;
  ngOnInit(): void {
    console.log(this.parentdata.prefilled);
    this.prefilledIds = new Set(
      this.parentdata.prefilled.map((item: any) => item.m_hash_id)
    );
    this.page = 1;
    this.targetList = [];
    this.selectedTargets = [];
    this.route.queryParams.subscribe((data) => {
      if (data.entityHash) {
        this.isloader = true;
        this.entityHash = data.entityHash;
        if (this.parentdata.type == "customer") {
          this.type = this.parentdata.type;
          this.apiservice.getCustomersByEntityId(
            this.entityHash,
            this.page.toString(),
            "25"
          );
        } else if (this.parentdata.type == "member") {
          this.type = this.parentdata.type;
          this.apiservice.getEnrolledMembersListByType(
            this.entityHash,
            "1",
            this.page,
            "25"
          );
        } else if (this.parentdata.type == "query") {
          this.type = this.parentdata.type;
          this.apiservice.getAllEnrollOpenInterestByEntityId(
            this.entityHash,
            this.page
          );
        } else if (this.parentdata.type == "service querie") {
          this.type = this.parentdata.type;
          this.apiservice.getEntityAllEnquiryList(this.entityHash, this.page);
        }
      }
    });
  }

  selectedTargets: any = [];
  selectTarget(item: any) {
    // this.targetList.forEach((element:any) => {
    //   element.selected = false
    // });
    item.selected = !item.selected;
    if (item.selected) {
      this.selectedTargets.push(item);
    } else {
      const index = this.selectedTargets.findIndex(
        (data: any) => item.hash_id === data.hash_id
      );
      this.selectedTargets.splice(index, 1);
    }
  }

  onpost() {
    let parsedData = this.selectedTargets.map((data: any) => {
      return {
        m_hash_id: data?.hash_id ?? null,
        target_name: data.name ?? data.customer_name,
        country_code: data.country_code ?? data.customer_country_code,
        phone_no: data.phone ?? data.customer_phone,
        image_thumb_url: data?.image_thumb_url ?? null,
      };
    });
    this.activemodal.close(parsedData);
  }
  loader: boolean = false;
  seeMore() {
    this.loader = true;
    this.page += 1;
    if (this.type == "customer") {
      this.apiservice.getCustomersByEntityId(
        this.entityHash,
        this.page.toString(),
        "25"
      );
    } else if (this.type == "member") {
      this.apiservice.getEnrolledMembersListByType(
        this.entityHash,
        "1",
        this.page,
        "25"
      );
    } else if (this.type == "query") {
      this.type = this.parentdata.type;
      this.apiservice.getAllEnrollOpenInterestByEntityId(
        this.entityHash,
        this.page
      );
    } else if (this.type == "service querie") {
      this.type = this.parentdata.type;
      this.apiservice.getEntityAllEnquiryList(this.entityHash, this.page);
    }
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
}
